import { Flex } from '@chakra-ui/react';

export type PageActionsProps = {
  pageActions?: React.ReactElement;
};

const PageActions = ({ pageActions }: PageActionsProps) => {
  if (!pageActions) return null;

  return (
    <Flex justifyContent="flex-end" mb={4}>
      {pageActions}
    </Flex>
  );
};

export default PageActions;
